module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title"
  }, [_vm._v("Acknowledgements")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When I decided I wanted to write about the Typhoon, it soon became apparent that to do justice to the subject and to differ from other books about an aeroplane, I needed to approach it in a different way from my other books. I therefore decided that I needed to talk at length with the men who had flown Typhoons. I had been encouraged when writing my book "), _c('i', [_vm._v("The Battle of the Airfields")]), _vm._v(" (Grub Street, 2000) to have contacted a number of Typhoon men who had been eager to help. I was fortunate that they not only agreed to help me with a book on the Typhoon, but were equally happy for me to interview them in their homes. These, and a number of others, all assisted me greatly and it was a personal pleasure for me to be able to meet every one of them, or nearly all, and be able to talk over their experiences to achieve what I desired for this book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The only notable exceptions were the two men in New Zealand, two in Australia and one in South Africa. Luckily, each one of them sent a wealth of information and interpreted my requirements almost as if I had interviewed them. To them and to everyone listed below, I give sincere thanks. I have used their words as they spoke or wrote them. I had no desire to try to improve or to comment on what they experienced flying the Typhoon in action. It is what they did, what they felt and what they thought. This is the story of the Hawker Typhoon, but it is also their story, and the story of their many contemporaries, many of whom did not survive to see victory. Gentlemen, I thank you.")]), _vm._v(" "), _c('div', {
    staticClass: "bq"
  }, [_c('p', {
    staticClass: "ref"
  }, [_vm._v("Air Chief Marshal Sir David Evans "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GCB CBE CBIM")]), _vm._v(": 137 Squadron")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Air Commodore C.D. North-Lewis "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DSO DFC")]), _vm._v("*: 175, 182, 181 Squadrons and 124 Wing.")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Group Captain H.S.L. Dundas "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DSO")]), _vm._v("* "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DFC")]), _vm._v(": 56 Squadron")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Group Captain D.E. Gillam "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DSO")]), _vm._v("** "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DFC")]), _vm._v("* "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AFC")]), _vm._v(": Duxford Wing, Leader 146 Wing.")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Group Captain F.W.M. Jensen "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CBE DFC")]), _vm._v("* "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AFC AE FBIM:")]), _vm._v(" 195 & 181 Squadrons")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Wing Commander H. Ambrose "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DFC")]), _vm._v("*: 257, 175 & 181 Squadrons")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Wing Commander S.J. Eaton "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DFC")]), _vm._v(": 257 Squadron")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Wing Commander G.J. Gray "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DFC")]), _vm._v("*: 181 & 182 Squadrons")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Wing Commander L.H. Lambert "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DFC AFC")]), _vm._v(": 168 Squadron")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Wing Commander P.H.M. Richey "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DFC")]), _vm._v("*: 609 Squadron")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Wing Commander B.J. Spragg "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DFC")]), _vm._v(": 257 Squadron")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Wing Commander A.G. Todd "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DFC")]), _vm._v(": 56, 164, 193 and 257 Squadrons")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Squadron Leader G. Clubley "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DFC:")]), _vm._v(" 181 and 137 Squadrons")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Squadron Leader H.G. Pattison "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DFC OStJ")]), _vm._v(": 182 Squadron")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Squadron Leader A.H. Smith "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DFC")]), _vm._v("*: 486 and 197 Squadrons")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Flight Lieutenant R.W. Cole "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DFC")]), _vm._v(": 3 Squadron")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Flight Lieutenant V.C. Fittall "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DFC")]), _vm._v(": 486 & 198 Squadrons")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Flight Lieutenant R.E.G. Sheward "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DFC")]), _vm._v(": 137, 164, 263 & 266 Squadrons")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Flight Lieutenant J.G. Simpson "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DFC")]), _vm._v(": 193 Squadron")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Flying Officer T.T. Hall "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DFC")]), _vm._v(": 175 Squadron")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Flying Officer R.W. Pottinger: 3 Squadron")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Flying Officer A. Shannon: 257 & 197 Squadrons")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Flying Officer W.R. Speedie: 175 Squadron")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Pilot Officer N.B. Wilson: Tech Adj")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("LAC K.F. Figg: 182 Squadron")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("LAC D.C. Shepherd: 137 Squadron")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("LAC D.N. Macdonald: 121 Wing")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Thanks are also due to Mrs Phyllis Russell, Martyn Ford-Jones, Chris Thomas, Geoff Thomas, Chaz Bowyer, The Keeper of the Public Records Office, Kew; Amy Myers and all at Grub Street, and not least my dear wife Heather, and as always my two coffee-making sons Rob and Mike.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0db2cf0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Acknowledgement.vue
// module id = 75
// module chunks = 0